import { IoMdSkipBackward } from "react-icons/io";
import { IoMdPlay } from "react-icons/io";
import { IoMdRepeat } from "react-icons/io";
import { MdFastForward } from "react-icons/md";
import { MdLightbulb } from "react-icons/md";
import { MdVolumeMute } from "react-icons/md";
import { MdPause } from "react-icons/md";
import { MdStop } from "react-icons/md";
import { IoMdPower } from "react-icons/io";
import { MdMediaBluetoothOn } from "react-icons/md";
import { GiUsbKey } from "react-icons/gi";
import RadioIcon from '@mui/icons-material/Radio';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import { EButtonIcons } from "../local-interfaces/local-enum";

export function useOnIcons() {
  return {
    images: getImage(),
  };

  function getImage(): (iconName: string) => any {
    return (iconName: string) => {
      switch (iconName) {
        case EButtonIcons.backward:
          return <IoMdSkipBackward />;
        case EButtonIcons.forward:
          return <MdFastForward />;
        case EButtonIcons.light:
          return <MdLightbulb />;
        case EButtonIcons.mute:
          return <MdVolumeMute />;
        case EButtonIcons.pause:
          return <MdPause />;
        case EButtonIcons.play:
          return <IoMdPlay />;
        case EButtonIcons.reboot:
          return <IoMdPower />;
        case EButtonIcons.repeat:
          return <IoMdRepeat />;
        case EButtonIcons.stop:
          return <MdStop />;
        case EButtonIcons.bluetooth:
          return <MdMediaBluetoothOn />;
        case EButtonIcons.usb:
          return <GiUsbKey />;
        case EButtonIcons.radio:
          return <RadioIcon />
        case EButtonIcons.stream:
          return <SettingsInputAntennaIcon />

        default:
          break;
      }
    };
  }
}
